<template>
	<div id="page-user-edit">
		<bread-crumbs
			v-if="activeTab === 0"
			:title="$t('general.Activities')"
			:subTitle="$t('general.SubtitleActivity')"
			:sizeTitle="30"
			:lineHeightTitle="37"
			:sizeSubTitle="15"
			:lineHeightSubTitle="18"
		>
		</bread-crumbs>
		<div :class="activeTab === 0 ? 'vx-card p-4' : ''">
			<div v-if="activeTab === 0" class="tab-text">
				<activity-list-view
					v-if="activityReadPermission"
					@selectedActivityEmit="selectedActivityEmit"
					@valueCreateActivity="valueActivityEmit"
				/>
				<not-permission v-else :message="messageRead"></not-permission>
			</div>
			<div v-else-if="activeTab === 1" class="tab-text">
				<template>
					<bread-crumbs
						class="ml-1"
						:title="
							activityData.id > 0
								? $t('Crud.Update') + ' ' + $t('Activity.Activity')
								: $t('general.New2') + ' ' + $t('Activity.Activity')
						"
						:subTitle="
							activityData.id > 0
								? $t('general.SubtitleActivityUpdate')
								: $t('general.SubtitleActivityCreate')
						"
						:sizeTitle="22"
						:lineHeightTitle="27"
						:sizeSubTitle="13"
						:lineHeightSubTitle="16"
					>
					</bread-crumbs>
					<div class="vx-row mb-2">
						<div class="vx-col w-full flex items-center">
							<feather-icon
								class="g-breadcrumb--title"
								icon="ChevronLeftIcon"
								svgClasses="h-8 w-8"
								@click.prevent="valueActivityEmit(0)"
							/>
							<vs-breadcrumb
								class="g-breadcrumb--title"
								separator=""
								:items="[{title: $t('general.Return')}]"
								@click.prevent="valueActivityEmit(0)"
							></vs-breadcrumb>
						</div>
					</div>
				</template>
				<activity-create-tab-information
					v-if="activityCreatePermission && activityData.id === 0"
					:data="activityData"
					@changeActiveTabEmit="valueActivityEmit"
				/>
				<activity-create-tab-information
					v-else-if="activityUpdatePermission && activityData.id > 0"
					:data="activityData"
					@changeActiveTabEmit="valueActivityEmit"
				/>
				<not-permission v-else :message="messageCreateOrUpdate"></not-permission>
			</div>
		</div>
	</div>
</template>

<script>
import ActivityCreateTabInformation from "./ActivityCreateTabInformation.vue";
import ActivityListView from "./ActivityListView.vue";
import Activity from "@/models/Activity.js";
import NotPermission from "@/views/pages/NotPermission.vue";

export default {
	components: {
		ActivityCreateTabInformation,
		ActivityListView,
		NotPermission,
	},
	data() {
		return {
			activityData: new Activity({}),
			user_not_found: false,
			activeTab: 0,
		};
	},
	computed: {
		activityReadPermission() {
			return this.$store.getters.checkPermission("ACTIVITY_R");
		},
		activityCreatePermission() {
			return this.$store.getters.checkPermission("ACTIVITY_C");
		},
		activityUpdatePermission() {
			return this.$store.getters.checkPermission("ACTIVITY_U");
		},
		nameTabOne() {
			return this.activityData.id > 0 ? this.$t("UpdateActivity") : this.$t("CreateActivity");
		},
		messageRead() {
			return `${this.$t("Permissions.RequiredPermissions")} "ACTIVITY_R"`;
		},
		messageCreateOrUpdate() {
			return this.activityData.id > 0
				? `${this.$t("Permissions.RequiredPermissions")} "ACTIVITY_U"`
				: `${this.$t("Permissions.RequiredPermissions")} "ACTIVITY_C"`;
		},
	},
	watch: {
		activeTab(tabNum) {
			if (tabNum === 0) {
				this.activityData = new Activity({});
			}
		},
	},
	methods: {
		selectedActivityEmit(activity) {
			this.activityData = activity;
			this.activeTab = 1;
		},
		valueActivityEmit(val) {
			this.activeTab = val;
			if (this.activeTab === 0) {
				this.activityData = new Activity({});
			}
		},
	},
};
</script>
